import get from 'lodash/get';

import { BannerQueryResult } from '../graphql/types';

export const getAnalyticsBannerData = (data: BannerQueryResult['data']) => {
  const companyName =
    get(data?.banner, 'offeringClosingFirst.companyName') ??
    get(data?.banner, 'investment.offering.companyName');
  const offeringSlug =
    get(data?.banner, 'offeringClosingFirst.slug') ??
    get(data?.banner, 'investment.offering.slug');
  const daysLeft = get(data?.banner, 'timeLeft');
  return {
    banner_name: data?.banner?.__typename,
    extra_data: { companyName, offeringSlug, daysLeft },
  };
};
